import { userActionTypes } from '../actions/types';

export function registration(state = {}, action) {
  switch (action.type) {
    case userActionTypes.REGISTER_REQUEST:
      return {
        ...state,
        error: null,
        registerState: 'registering',
      };
    case userActionTypes.REGISTER_SUCCESS:
      return {
        ...state,
        registerState: 'succeeded',
      };
    case userActionTypes.REGISTER_FAILURE:
      return {
        ...state,
        registerState: 'failed',
        error: action.error,
      };
    case userActionTypes.CONFIRM_MOBILE_REQUEST:
      return {
        ...state,
        error: null,
        registerState: 'confirming',
      };
    case userActionTypes.CONFIRM_MOBILE_SUCCESS:
      return {
        ...state,
        registerState: 'succeeded',
      };
    case userActionTypes.CONFIRM_MOBILE_FAILURE:
      return {
        ...state,
        registerState: 'failed',
        error: action.error,
      };
    case userActionTypes.RESEND_CONFIRMATION_SMS_REQUEST:
      return {
        ...state,
        error: null,
        resendSMSState: 'resending',
      };
    case userActionTypes.RESEND_CONFIRMATION_SMS_SUCCESS:
      return {
        ...state,
        resendSMSState: 'success',
      };
    case userActionTypes.RESEND_CONFIRMATION_SMS_FAILURE:
      return {
        ...state,
        resendSMSState: 'failure',
        error: action.error,
      };
    case userActionTypes.RESET_STATE:
      return {};
    default:
      return state;
  }
}
